import axios from "../../config/axiosConfig";
import {
  CREATE_GENERAL_PURCHASE_RETURN_BILL, DELETE_GENERAL_PURCHASE_RETURN_BILL,
  GET_GENERAL_PURCHASE_RETURN_BILLS,
  GET_GENERAL_PURCHASE_RETURN_BILLS_PAGE,
  GENERAL_PURCHASE_RETURN_BILL_REQUEST,
  GENERAL_PURCHASE_RETURN_BILL_REQUEST_SUCCESS,
  GENERAL_PURCHASE_RETURN_BILL_REQUEST_FAILURE,
  UPDATE_GENERAL_PURCHASE_RETURN_BILL
} from "../types";

export const getValidatedIncrementedVchNoGeneralPurchaseReturnBill = (currentVchNo) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id
      };
      
      const response = await axios.get("/general-purchase-return-bill/get-next-vch-no", { params });
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getGeneralPurchaseReturnBillsWithPagination = (page, limit, include, searchStr, searchCols, where, addTotal) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GENERAL_PURCHASE_RETURN_BILL_REQUEST });
      
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id, companyId: auth.company?.id,
        page, limit, include, addTotal, search: searchStr, searchCols, where,
        includeAttr: 'Account_Id,Expense_Account_Id'
      };
      return axios.get("/general-purchase-return-bill/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_GENERAL_PURCHASE_RETURN_BILLS_PAGE, payload: { ...response.data, where } });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: GENERAL_PURCHASE_RETURN_BILL_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: GENERAL_PURCHASE_RETURN_BILL_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getGeneralPurchaseReturnBills = (include) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GENERAL_PURCHASE_RETURN_BILL_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      if (include) {
        params = { ...params, include };
      }
      return axios.get("/general-purchase-return-bill/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_GENERAL_PURCHASE_RETURN_BILLS, payload: response.data?.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: GENERAL_PURCHASE_RETURN_BILL_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: GENERAL_PURCHASE_RETURN_BILL_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getGeneralPurchaseReturnBillsByRange = (billId, from, to) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        billId, from, to
      };
      
      const response = await axios.get("/general-purchase-return-bill/getAll", { params });
      return response.data;

    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getGeneralPurchaseReturnBillById = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GENERAL_PURCHASE_RETURN_BILL_REQUEST });
    
      return axios.get(`/general-purchase-return-bill/get/${id}`).then((response) => {
        dispatch({ type: GENERAL_PURCHASE_RETURN_BILL_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: GENERAL_PURCHASE_RETURN_BILL_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: GENERAL_PURCHASE_RETURN_BILL_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const createGeneralPurchaseReturnBill = (generalPurchaseReturnBill) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: GENERAL_PURCHASE_RETURN_BILL_REQUEST });
      const newGeneralPurchaseReturnBill = {
        ...generalPurchaseReturnBill
      };
      return axios.post("/general-purchase-return-bill/add", newGeneralPurchaseReturnBill,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_GENERAL_PURCHASE_RETURN_BILL, payload: response.data });
        } else {
          dispatch({
            type: GENERAL_PURCHASE_RETURN_BILL_REQUEST_FAILURE,
            error: "Purchase bill create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: GENERAL_PURCHASE_RETURN_BILL_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: GENERAL_PURCHASE_RETURN_BILL_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateGeneralPurchaseReturnBill = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GENERAL_PURCHASE_RETURN_BILL_REQUEST });
      const { auth } = getState();
      return axios.put("/general-purchase-return-bill/update", { id, data },
        { params: {
          userId: auth.user?.id,
          companyId: data.Company_Id || auth.company?.id,
          finyearId: data.Finyear_Id || auth.finyear?.id,
          customerId: data.Customer_Id || auth?.user?.Customer_Id,
        }}
      ).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_GENERAL_PURCHASE_RETURN_BILL,
            payload: { id, data: response.data },
          });
        } else {
          dispatch({
            type: GENERAL_PURCHASE_RETURN_BILL_REQUEST_FAILURE,
            error: "Purchase bill update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: GENERAL_PURCHASE_RETURN_BILL_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: GENERAL_PURCHASE_RETURN_BILL_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteGeneralPurchaseReturnBill = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GENERAL_PURCHASE_RETURN_BILL_REQUEST });
      return axios.delete(`/general-purchase-return-bill/delete/${id}`).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_GENERAL_PURCHASE_RETURN_BILL, id: id });
          const include = ['id', 'Entry_No', 'Bill_No', 'Date', 'Account_Id', 'Original_Invoice_No', 'Expense_Account_Id', 'Amount', 'Net_Total'].join(',');
          const searchCols = ['Entry_No', 'Bill_No'].join(',');
          const { inventory: { generalPurchaseReturnBill: { page, pageSize, search, where } = {} } } = getState();
          dispatch(getGeneralPurchaseReturnBillsWithPagination(page, pageSize, include, search, searchCols, where, true));
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: GENERAL_PURCHASE_RETURN_BILL_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: GENERAL_PURCHASE_RETURN_BILL_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const sendMailGeneralPurchaseReturn = (mailData) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GENERAL_PURCHASE_RETURN_BILL_REQUEST });
      const { auth } = getState();
      
      // Create FormData to handle file attachment
      const formData = new FormData();
      formData.append('to', mailData.to);
      formData.append('templateId', mailData.templateId);
      formData.append('generalPurchaseReturnId', mailData.generalPurchaseReturnId);
      formData.append('finyearId', auth.finyear?.id);
      formData.append('companyId', auth.company?.id);
      formData.append('customerId', auth?.user?.Customer_Id);
      formData.append('recipientType', mailData.recipientType || 'custom');
      formData.append('moduleName', mailData.moduleName);
      
      // Add PDF attachment if exists
      if (mailData.pdfAttachment) {
        formData.append('attachment', mailData.pdfAttachment, `general_purchase_return_${mailData.generalPurchaseReturnId}.pdf`);
      }
      // console.log('formData>>',formData);
      return axios.post("/general-purchase-return-bill/mail-send", formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((response) => {
        if (response.data) {
          dispatch({ type: GENERAL_PURCHASE_RETURN_BILL_REQUEST_SUCCESS });
          return response.data;
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ 
          type: GENERAL_PURCHASE_RETURN_BILL_REQUEST_FAILURE, 
          error: error.message 
        });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ 
        type: GENERAL_PURCHASE_RETURN_BILL_REQUEST_FAILURE, 
        error: error.message 
      });
      throw error;
    }
  };
};

export const sendWhatsappGeneralPurchaseReturn = (whatsappData) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GENERAL_PURCHASE_RETURN_BILL_REQUEST });
      const { auth } = getState();
      
      // Create FormData to handle file attachment
      const formData = new FormData();
      formData.append('to', whatsappData.to);
      formData.append('templateId', whatsappData.templateId);
      formData.append('generalPurchaseReturnId', whatsappData.generalPurchaseReturnId);
      formData.append('finyearId', auth.finyear?.id);
      formData.append('companyId', auth.company?.id);
      formData.append('customerId', auth?.user?.Customer_Id);
      formData.append('recipientType', whatsappData.recipientType || 'custom');
      
      // Add PDF attachment if exists
      if (whatsappData.pdfAttachment) {
        formData.append('attachment', whatsappData.pdfAttachment, `general_purchase_return_${whatsappData.generalPurchaseReturnId}.pdf`);
      }
      // console.log('formData>>',formData);
      return axios.post("/general-purchase-return-bill/whatsapp-send", formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((response) => {
        if (response.data) {
          dispatch({ type: GENERAL_PURCHASE_RETURN_BILL_REQUEST_SUCCESS });
          return response.data;
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ 
          type: GENERAL_PURCHASE_RETURN_BILL_REQUEST_FAILURE, 
          error: error.message 
        });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ 
        type: GENERAL_PURCHASE_RETURN_BILL_REQUEST_FAILURE, 
        error: error.message 
      });
      throw error;
    }
  };
};